module.exports = __webpack_public_path__ + "img/graphs.c9803c48.svg";